export const addButtonWrapperSx = { display: 'flex', justifyContent: 'flex-end', mb: 2 };

export const locationTableWrapperSx = { px: '32px', pb: '32px', pt: '48px' };
